<script setup lang="ts">
const {
  data: siteData,
  error: siteError,
  refresh,
} = await useFetch('/api/site-data', {
  key: 'site-data',
});
// make sitedata available globally
useState('siteData', () => siteData);

const { isVisualEditingEnabled, apply } = useVisualEditing();

import Toaster from '~/components/shared/Toaster.vue';

const navigation = useTemplateRef('navigationRef');
const footer = useTemplateRef('footerRef');

if (siteError.value) {
  throw createError({
    statusCode: 500,
    statusMessage: 'Failed to load site data. Please try again later.',
    fatal: true,
  });
}

useHead({
  style: [
    {
      id: 'accent-color',
      innerHTML: `:root { --accent-color: ${unref(siteData)?.globals.accent_color || '#6644ff'} !important; }`,
    },
  ],
  bodyAttrs: {
    class: 'antialiased',
  },
});

useSeoMeta({
  titleTemplate: `%s / ${unref(siteData)?.globals.title}`,
  ogSiteName: unref(siteData)?.globals.title,
});

onMounted(() => {
  if (!isVisualEditingEnabled.value) return;
  apply({
    elements: [navigation.value?.navigationRef as HTMLElement, footer.value?.footerRef as HTMLElement],
    onSaved: () => {
      refresh();
    },
  });
});
const { setAttr } = useVisualEditing();
</script>

<template>
  <div class="flex flex-col min-h-screen bg-tapis relative">
    <NavigationBar
      v-if="siteData?.headerNavigation"
      ref="navigationRef"
      :navigation="siteData.headerNavigation"
      :globals="siteData.globals"
    />
    <NuxtPage class="bg-tapis px-[--tapis] grow" :globals="siteData.globals" />
    <Footer
      v-if="siteData?.footerNavigation"
      ref="footerRef"
      :navigation="siteData.footerNavigation"
      :globals="siteData.globals"
      class="mt-auto"
    />
    <AdminBar />

    <Toaster />
  </div>
</template>
